(function($, Drupal) {
  Drupal.behaviors.reduce_motion = {
    attach: function(context, settings) {
      // Declare variables
      const $reduce_motion = $('#reduce-motion', context);
      const $hero_video = $('.field--name-field-media-video-file video', context);

      // Pause hero video and sliders if clicked
      if ($reduce_motion.length !== 0) {
        $reduce_motion.once('hero-video').on('click', function() {
          if ($(this).hasClass('paused')) {
            $hero_video.get(0).play();
            $(this).removeClass('paused');
          }
          else {
            $hero_video.get(0).pause();
            $(this).addClass('paused');
          }
        });
      }

      // if window width is less then 576px, remove the video
      if ($(window).width() < 576) {
        $hero_video.remove();
      }
    }
  };
})(jQuery, Drupal);
